import { useState } from "react";
import { motion } from "framer-motion";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import AdvantagesSection from "@/components/AdvantagesSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import VehicleClassificationSection from "@/components/VehicleClassificationSection";
import Decree140Section from "@/components/Decree140Section";
import CarExamplesSection from "@/components/CarExamplesSection";
import CalculatorSection from "@/components/CalculatorSection";
import CustomsNewsSection from "@/components/CustomsNewsSection";
import FAQSection from "@/components/FAQSection";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import TelegramWidget from "@/components/TelegramWidget";

export default function LandingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Header 
        mobileMenuOpen={mobileMenuOpen} 
        setMobileMenuOpen={setMobileMenuOpen} 
      />
      
      <main>
        <HeroSection />
        <ServicesSection />
        <AdvantagesSection />
        <HowItWorksSection />
        <CalculatorSection />
        <CarExamplesSection />
        <VehicleClassificationSection />
        <Decree140Section />
        <CustomsNewsSection />
        <FAQSection />
        <ContactForm />
      </main>
      
      <Footer />
      <TelegramWidget />
    </div>
  );
}
